import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels'
import {
  SvgShiftIcon,
  SvgVerticalSplitter,
  SvgArrowOut,
  Tabs,
  TabInterface,
  CustomButton,
  Accordion,
  FormInput,
  ControlledDropDown,
  ViewComponent,
  Checkbox,
  FIELD_VALUE_CONSTANTS,
  filterOperatorValues,
  FormDateInput,
  DATE_FIELD_TYPES,
  MULTI_UPLOAD_FILE_TYPE,
} from '@ui-kit'
import { useEffect, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../utils/agent.store'
import {
  showLoader,
  hideLoader,
  fetchCommunicationIdCorrespondingData,
  DropdownType,
  fetchWorkflowDefinitionsAPI,
  WorkflowDefinitionsListType,
  createWorkflowInstance,
  getServicesCorrespondingToProgramApi,
  flattenEntityRelationshipTree,
  getLayoutTree,
  updateRelationshipTree,
  updateRelationshipTreeObject,
  WorkflowInstanceType,
  WorkflowProcessType,
  getWorkflowByEntityNameAndRecordId,
  addToaster,
  LayoutResponseType,
  convertS3ToBase64,
} from '@app-store'
import DocumentPopout from '../../components/send-manual-communication/DocumentPopout'
import { ShortcutKeys } from '../../constants/form.constants'
import { FaxDetailsData } from '../../types/intakeQueue.types'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import FaxInfo from './FaxInfo'
import { useParams } from 'react-router-dom'
import { fetchDownloadUrlForSingleFIles } from '../../apis/fetchPresignedUrl.api'
import { FileDataFromExtraResource } from '../../types/common'
import {
  ENTITY_ID,
  ENTITY_NAME,
  EXTENSIONS,
  INTAKE_DOCUMENT,
  MODE_STATUS,
  NAMESPACES,
  PERMISSION_ACCESSIBILITY,
  PERMISSION_MODULES,
  RECORD_STATE,
  REPORTS,
} from '../../utils/constants'
import { capitalize, noop, uniqueId } from 'lodash'
import { FieldValues, useForm, useWatch } from 'react-hook-form'
import {
  formatLocalDateWithZone,
  getCurrentLocalDate,
} from '../../utils/date.utils'
import {
  editEntityDataEmbeddedAPI,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import EntityLayoutWrapper from '../call-interaction/EntityLayoutWrapper'
import {
  getContentType,
  getFileType,
  permissionObject,
} from '../../utils/helperFunctions'
import CallInteractionContextProvider from '../call-interaction/CallInteactionContext'
import { caseCancelOrVoidApi } from '../../apis/caseStatus.api'
import { STRINGS } from '../../utils/strings'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import FilePreview from './FilePreview'
import { FileType } from '../../utils/types'

const IntakeDocumentReview = () => {
  const dispatch = useAppDispatch()
  const { documentId } = useParams()
  const [documentDetails, setDocumentDetails] = useState<FaxDetailsData | null>(
    null
  )
  const [layoutInfo, setLayoutInfo] = useState<
    {
      layout?: LayoutResponseType | null
      recordData?: FieldValues | null
    }[]
  >([])
  const [allTabs, setAllTabs] = useState<TabInterface[]>([])
  const [instanceId, setInstanceId] = useState<number>()
  const [yesNoIds, setYesNoIds] = useState<Record<string, number | undefined>>()
  const [rightTabs, setRightTabs] = useState<TabInterface[]>([])
  const [defaultActiveTab, setDefaultActiveTab] = useState<TabInterface>()
  const [allAttachmentsData, setAllAttachmentsData] = useState<
    FileDataFromExtraResource[]
  >([])
  const [selectedFileType, setSelectedFileType] = useState<string>('')
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0)
  const [isViewMode, setIsViewMode] = useState(false)
  const [hasBeenSaved, setHasBeenSaved] = useState(false)
  const [isOverrideMode, setIsOverrideMode] = useState(false)
  const [documentUrl, setDocumentUrl] = useState('')
  const [activeTab, setActiveTab] = useState<TabInterface | null>()
  const [aepcOptions, setAepcOptions] = useState<DropdownType<string>[]>([])
  const [documentStatus, setDocumentStatus] = useState<string>()
  const [riDefinitionData, setRiDefinitionData] =
    useState<WorkflowDefinitionsListType>()
  const [programId, setProgramId] = useState<number>()
  const [serviceId, setServiceId] = useState<string>()
  const [urgencyIndexStatus, setUrgencyIndexStatus] = useState<string>()
  const [completionDate, setCompletionDate] = useState<string>()
  const [escalationDate, setEscalationDate] = useState<string>()
  const [overrideStatus, setOverrideStatus] = useState<string>('No')
  const [defaultFormValues, setDefaultFormValues] = useState({})
  const [isEditMode, setIsEditMode] = useState<Record<number, boolean>>({})
  const [selectedFilePath, setSelectedFilePath] = useState<string>('')
  const [docxPreviewUrl, setDocxPreviewUrl] = useState<string>('')
  const { control, watch, register, setValue, reset } = useForm()
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const currUserId = useAppSelector((state) => state?.authUser?.user?.id)
  const categoryMap = useAppSelector(
    (state) => state?.categoryDropdown?.categoryMap
  )
  const programPermissions = useAppSelector(
    (state) => state?.clientPermissions?.programPermissions
  )

  const aePcValue = useWatch({
    control,
    name: 'ae-pc-dropdown',
  })
  const aePcLabel = useMemo(
    () => aepcOptions?.find((opt) => opt.value === aePcValue)?.label,
    [aepcOptions, aePcValue]
  )
  const handleIsEditMode = (value: Record<number, boolean>) => {
    setIsEditMode(value)
  }

  const filteredAepcOptions = useMemo(() => {
    if (isOverrideMode) {
      return aepcOptions?.filter((opt) => opt.label !== INTAKE_DOCUMENT.UNSURE)
    }
    return aepcOptions
  }, [aepcOptions, isOverrideMode])

  const renderButtons = () => {
    if (defaultActiveTab?.label !== INTAKE_DOCUMENT.DETERMINE_AE_PC) {
      return null
    }
    if (
      !hasBeenSaved ||
      (documentStatus === MODE_STATUS.PENDING &&
        !documentDetails?.document_case)
    ) {
      return (
        <CustomButton
          isFilled={true}
          type="submit"
          onClick={(e) => {
            handleSaveAndNext(e)
          }}
          className="mr-4"
        >
          {NAMESPACES.SAVE_AND_NEXT_BUTTON}
        </CustomButton>
      )
    }
    if (isOverrideMode) {
      return (
        <div className="flex gap-2 mr-4">
          <CustomButton
            isFilled={false}
            onClick={() => {
              reset(defaultFormValues)
              setIsOverrideMode(false)
              setIsViewMode(true)
            }}
          >
            {NAMESPACES.CANCEL_BUTTON}
          </CustomButton>
          <CustomButton
            isFilled={true}
            type="button"
            onClick={(e) => handleUpdateButtonClick(e)}
          >
            {NAMESPACES.UPDATE_BUTTON}
          </CustomButton>
        </div>
      )
    }
    if (
      permissionObject.Queue_Review_Manage_Intake(
        programPermissions,
        PERMISSION_MODULES.OVERRIDE_AE_PC,
        PERMISSION_ACCESSIBILITY.MANAGE,
        programId?.toString() ?? ''
      ) &&
      (documentStatus !== MODE_STATUS.PENDING || documentDetails?.document_case)
    ) {
      return (
        <CustomButton
          isFilled={true}
          onClick={() => {
            setIsViewMode(false)
            setIsOverrideMode(true)
          }}
          className="mr-4"
        >
          {INTAKE_DOCUMENT.OVERRIDE}
        </CustomButton>
      )
    }
    return null
  }

  const getAccordionHeader = () => {
    return (
      <div className="flex justify-between items-center">
        <div className="text-sm font-normal">
          {INTAKE_DOCUMENT.AE_PC_INFORMATION}
        </div>
        {urgencyIndexStatus && (
          <div
            className={`text-xs font-light p-1 rounded ${
              urgencyIndexStatus === REPORTS.ON_TRACK
                ? 'bg-success-100'
                : urgencyIndexStatus === REPORTS.OVERDUE
                ? 'bg-error-50'
                : 'bg-progress-100'
            }`}
          >
            {urgencyIndexStatus}
          </div>
        )}
      </div>
    )
  }

  const caseTabs = useMemo(() => {
    return [
      {
        label: INTAKE_DOCUMENT.DETERMINE_AE_PC,
        component: (
          <form>
            <div>
              <Accordion heading={getAccordionHeader()} isDefaultActive={true}>
                <div className="mx-2 my-4 flex flex-col gap-4">
                  <div className="grid grid-cols-7 gap-x-3 gap-y-3">
                    <div className="col-span-2">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.DOCUMENT_CHANNEL}
                          data={watch('document-channel')}
                        />
                      ) : (
                        <FormInput
                          label={INTAKE_DOCUMENT.DOCUMENT_CHANNEL}
                          name="document-channel"
                          type="text"
                          disabled={true}
                          register={register}
                        />
                      )}
                    </div>
                    <div className="col-span-2">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.DETERMINE_AE_PC}
                          data={
                            aepcOptions?.find(
                              (opt) => opt.value === watch('ae-pc-dropdown')
                            )?.label || watch('ae-pc-dropdown')
                          }
                        />
                      ) : (
                        <ControlledDropDown
                          label={INTAKE_DOCUMENT.DETERMINE_AE_PC}
                          options={filteredAepcOptions}
                          name="ae-pc-dropdown"
                          onChange={noop}
                          control={control}
                          required={true}
                        />
                      )}
                    </div>
                    {isViewMode ? (
                      <div className="col-span-2">
                        <ViewComponent
                          label={INTAKE_DOCUMENT.OVERRIDE_STATUS}
                          data={overrideStatus}
                        />
                      </div>
                    ) : null}
                    {aePcLabel === INTAKE_DOCUMENT.UNSURE &&
                    !isViewMode &&
                    !isOverrideMode ? (
                      <div className="col-span-2">
                        <Checkbox
                          label={INTAKE_DOCUMENT.ESCALATED}
                          name="escalated-checkbox"
                          register={register}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="grid grid-cols-7 gap-x-3 gap-y-3">
                    <div className="col-span-2">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.DETERMINATION_USER_ID}
                          data={watch('determination-user-id')}
                        />
                      ) : (
                        <FormInput
                          label={INTAKE_DOCUMENT.DETERMINATION_USER_ID}
                          name="determination-user-id"
                          type="text"
                          disabled={true}
                          register={register}
                        />
                      )}
                    </div>
                    <div className="col-span-2">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.ACTUAL_DETERMINATION_DATE}
                          data={formatLocalDateWithZone(
                            watch('actual-determination-date')
                          )}
                        />
                      ) : (
                        <FormDateInput
                          label={INTAKE_DOCUMENT.ACTUAL_DETERMINATION_DATE}
                          name="actual-determination-date"
                          type={DATE_FIELD_TYPES.DATE_TIME_LOCAL}
                          isDisabled={true}
                          control={control}
                          min=""
                          max=""
                        />
                      )}
                    </div>
                    <div className="col-span-2">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.DETERMINATION_DUE_DATE}
                          data={formatLocalDateWithZone(
                            watch('determination-due-date')
                          )}
                        />
                      ) : (
                        <FormDateInput
                          label={INTAKE_DOCUMENT.DETERMINATION_DUE_DATE}
                          name="determination-due-date"
                          type={DATE_FIELD_TYPES.DATE_TIME_LOCAL}
                          isDisabled={true}
                          control={control}
                          min=""
                          max=""
                        />
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-4">
                    <div className="col-span-4">
                      {isViewMode ? (
                        <ViewComponent
                          label={INTAKE_DOCUMENT.JUSTIFICATION_COMMENT}
                          data={watch('justification-comment')}
                        />
                      ) : (
                        <FormInput
                          label={INTAKE_DOCUMENT.JUSTIFICATION_COMMENT}
                          name="justification-comment"
                          type="textbox"
                          required={isOverrideMode}
                          register={register}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Accordion>
            </div>
          </form>
        ),
      },
      ...rightTabs,
    ]
  }, [
    rightTabs,
    aepcOptions,
    isViewMode,
    watch,
    riDefinitionData,
    hasBeenSaved,
    isOverrideMode,
    aePcValue,
    filteredAepcOptions,
  ])

  const handleSaveAndNext = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const selectedAepcId = watch('ae-pc-dropdown')
    const selectedAepc = aepcOptions.find(
      (item) => item.value === selectedAepcId
    )?.label
    if (!selectedAepc) {
      dispatch(
        addToaster({
          message: NAMESPACES.REQUIRED_TOAST,
          type: 'error',
          id: uniqueId(),
        })
      )
      return
    }
    if (
      selectedAepc !== INTAKE_DOCUMENT.NONE &&
      selectedAepc !== INTAKE_DOCUMENT.UNSURE
    ) {
      createWorkflowInstanceForRI()
    } else {
      await saveAndUpdateDocument(yesNoIds?.No ?? 0)
      await fetchDocumentDetails()
    }
    setIsOverrideMode(false)
  }

  const fetchDocumentDetails = async () => {
    try {
      dispatch(showLoader())
      const payload = {
        entity_name: QUEUE_STRINGS?.AE_PC_DOCUMENT,
        select: [
          'programs',
          'created_at',
          'channel',
          'users',
          'documents',
          'ae_pc_status',
          'determination_status',
          'determination_user',
          'actual_determination_date',
          'document_case',
          'urgency_index_status',
          'justification_comment',
          'document_type',
          'override_status',
          'completion_date',
          'escalation_date',
        ],
        related_entities: {
          determination_user: {
            select: ['first_name', 'last_name', 'email'],
          },
          users: {
            select: ['first_name', 'last_name', 'email'],
          },
          documents: {
            select: ['attachment', 'document_key'],
          },
          urgency_index_status: {
            select: ['overdue_time'],
          },
        },
      }
      const response = await fetchCommunicationIdCorrespondingData(
        parseInt(documentId ?? ''),
        payload
      )
      setDocumentDetails(response?.data)
      setProgramId(response?.data?.programs?.id)
      setCompletionDate(response?.data?.completion_date)
      setEscalationDate(response?.data?.escalation_date)
      setDocumentStatus(capitalize(response?.data?.ae_pc_status))
      if (
        response?.data?.ae_pc_status !== MODE_STATUS.PENDING.toUpperCase() ||
        response?.data?.document_case
      ) {
        setIsViewMode(true)
        setHasBeenSaved(true)
      }
      if (response?.data?.document_case) {
        try {
          const newTabs = []
          const resp = await getWorkflowByEntityNameAndRecordId({
            entityName: ENTITY_NAME.CASE_LOWER,
            recordId: response?.data?.document_case?.id,
          })
          setInstanceId(resp.data.workflow_instance?.id)
          newTabs.push({
            label: `Case ID - ${response?.data?.document_case?.case_key}`,
            key: response?.data?.document_case?.case_key,
            component: (
              <div className="mt-[-1rem]">
                <EntityLayoutWrapper
                  key={response?.data?.document_case?.case_key}
                  caseId={response?.data?.document_case?.id}
                  definition={resp.data.process}
                  instance={resp.data.workflow_instance}
                  workflowIndex={newTabs.length}
                />
              </div>
            ),
          })
          setRightTabs(newTabs)
          setLayoutInfo((prev) => {
            prev.push({
              layout: undefined,
              recordData: undefined,
            })
            return prev
          })
        } catch (err) {
          console.log(err)
        }
      }
      if (response?.data?.documents?.attachment?.length) {
        setAllAttachmentsData(response?.data?.documents?.attachment)
        displayAllTabs(response?.data?.documents?.attachment)
      }
      setValue('document-channel', response?.data?.channel?.value)
      setValue(
        'ae-pc-dropdown',
        response?.data?.determination_status?.id?.toString()
      )
      setOverrideStatus(response?.data?.override_status?.value)
      if (response?.data?.determination_user) {
        setValue(
          'determination-user-id',
          response?.data?.determination_user?.first_name +
            ' ' +
            response?.data?.determination_user?.last_name +
            ' | ' +
            response?.data?.determination_user?.email
        )
      }
      if (response?.data?.actual_determination_date) {
        setValue(
          'actual-determination-date',
          response?.data?.actual_determination_date
        )
      }
      if (response?.data?.urgency_index_status) {
        setValue(
          'determination-due-date',
          response?.data?.urgency_index_status?.overdue_time
        )
        setUrgencyIndexStatus(response?.data?.urgency_index_status?.status)
      }
      if (response?.data?.justification_comment) {
        setValue('justification-comment', response?.data?.justification_comment)
      }
      setDefaultFormValues({
        'ae-pc-dropdown': response?.data?.determination_status?.id?.toString(),
        'justification-comment': response?.data?.justification_comment,
        'document-channel': response?.data?.channel?.value,
        'determination-user-id':
          response?.data?.determination_user?.first_name +
          ' ' +
          response?.data?.determination_user?.last_name +
          ' | ' +
          response?.data?.determination_user?.email,
        'actual-determination-date': response?.data?.actual_determination_date,
        'determination-due-date':
          response?.data?.urgency_index_status?.overdue_time,
      })
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  const openWindow = () => {
    const currTabIndex = allTabs.findIndex(
      (tab) => tab.label === activeTab?.label
    )
    const url = new URL(window.location.href)
    url.search = ''
    url.hash = ''
    const basePath = url.pathname.endsWith('/')
      ? url.pathname.slice(0, -1)
      : url.pathname
    const popupUrl = `${url.origin}${basePath}/popup/${
      currTabIndex === -1 ? 0 : currTabIndex
    }`

    window.open(popupUrl, '_blank', 'width=600,height=450,left=200,top=200')
  }
  const handleDocumentSelected = async (index: number) => {
    try {
      dispatch(showLoader())
      setCurrentDocumentIndex(index)
      const { path, name } = allAttachmentsData[index]
      const { data } = await fetchDownloadUrlForSingleFIles(
        path,
        name,
        documentDetails?.documents?.id
      )
      if (data) {
        setDocumentUrl(data?.url)
        setSelectedFileType(getContentType(allAttachmentsData[index]))
        setSelectedFilePath(path + '/' + name)
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const generateDocumentUrl = async () => {
    try {
      const { path, name } = allAttachmentsData[currentDocumentIndex]
      const { data } = await fetchDownloadUrlForSingleFIles(
        path,
        name,
        documentDetails?.documents?.id
      )
      if (data?.url) {
        setDocumentUrl(data.url)
        return data.url
      }
      return documentUrl
    } catch (err) {
      console.log(err)
      return documentUrl
    }
  }

  const fileType = useMemo(() => {
    let type = getFileType(selectedFileType, documentUrl)
    if (type === EXTENSIONS.UNSUPPORTED) {
      type = EXTENSIONS.PDF as FileType
    }
    return type
  }, [selectedFileType, documentUrl])

  const displayAllTabs = (attachmentData: FileDataFromExtraResource[]) => {
    if (attachmentData.length === 1) {
      setAllTabs([])
      setActiveTab(null)
      return
    }
    const tabs: TabInterface[] = []
    attachmentData.map((attachment) =>
      tabs.push({
        label: attachment.name,
        component: null,
      })
    )
    setAllTabs(tabs)
    setActiveTab(tabs[0])
  }
  const fetchAEPCValues = () => {
    try {
      dispatch(showLoader())
      const options = categoryMap['Determine AE/PC']?.map((item) => ({
        label: item.label ?? '',
        value: item.id.toString(),
      }))
      setAepcOptions(options)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchYesOrNoIds = () => {
    const yesId = categoryMap['Yes No']?.find(
      (item) => item.value === NAMESPACES.YES
    )?.id
    const noId = categoryMap['Yes No']?.find(
      (item) => item.value === NAMESPACES.NO
    )?.id
    setYesNoIds({
      Yes: yesId,
      No: noId,
    })
  }

  const handleTabChange = (label: string, index: number) => {
    handleDocumentSelected(index)
    setActiveTab({ label: label, component: null })
  }
  const fetchServices = async () => {
    if (!programId) return
    try {
      dispatch(showLoader())
      const response = await getServicesCorrespondingToProgramApi(
        programId ?? 0
      )
      const id = response.data.find(
        (item: { service_name: string }) =>
          item.service_name === INTAKE_DOCUMENT.REPORTABLE_INCIDENT
      ).id
      setServiceId(id.toString())
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchDefinitions = async () => {
    if (!serviceId) return
    try {
      dispatch(showLoader())
      const searchCriteria = [
        {
          search_key: 'PROGRAM_ID',
          search_value: [programId?.toString() ?? ''],
          operator: filterOperatorValues.EQUALS,
        },
        {
          search_key: 'SERVICE_ID',
          search_value: [serviceId ?? ''],
          operator: filterOperatorValues.EQUALS,
        },
        {
          search_key: 'INDEPENDENT',
          search_value: ['true'],
          operator: filterOperatorValues.EQUALS,
        },
        {
          search_key: 'RECORD_STATUS',
          search_value: ['ACTIVE'],
          operator: filterOperatorValues.EQUALS,
        },
      ]
      const response = await fetchWorkflowDefinitionsAPI(searchCriteria)
      if (response?.data) {
        setRiDefinitionData(response.data.content[0])
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchRelationshipTree = async ({ entityId }: { entityId: string }) => {
    try {
      const response = await getLayoutTree(
        entityId || '',
        FIELD_VALUE_CONSTANTS?.ONE?.toString()
      )
      if (response?.data) {
        dispatch(
          updateRelationshipTree(flattenEntityRelationshipTree(response?.data))
        )
        dispatch(
          updateRelationshipTreeObject({
            [response?.data?.entity_name ?? '']: { ...response?.data },
          })
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveAndUpdateDocument = async (
    overrideStatus: number,
    case_id?: string,
    unlinkCase = false
  ) => {
    try {
      dispatch(showLoader())
      const data: {
        document_case?: {
          id: string
          _state: string
        }
        determination_user: {
          id: number | undefined
          _state: string
        }
        actual_determination_date: string
        justification_comment: string
        determination_status: {
          id: number
          _state: string
        }
        override_status: {
          id: number
          _state: string
        }
        ae_pc_status?: string
        completion_date?: string
        escalation_date?: string
      } = {
        determination_user: {
          id: currUserId,
          _state: RECORD_STATE.ADDED,
        },
        actual_determination_date: new Date().toISOString(),
        justification_comment: watch('justification-comment'),
        determination_status: {
          id: Number(watch('ae-pc-dropdown')),
          _state: RECORD_STATE.ADDED,
        },
        override_status: {
          id: overrideStatus ?? 0,
          _state: RECORD_STATE.ADDED,
        },
      }
      const embedded = [
        'determination_user',
        'actual_determination_date',
        'justification_comment',
        'determination_status',
        'override_status',
      ]
      if (aePcLabel === INTAKE_DOCUMENT.UNSURE && watch('escalated-checkbox')) {
        data.ae_pc_status = INTAKE_DOCUMENT.ESCALATED.toUpperCase()
        embedded.unshift('ae_pc_status')
      } else if (aePcLabel === INTAKE_DOCUMENT.NONE) {
        data.ae_pc_status = MODE_STATUS.COMPLETED.toUpperCase()
        embedded.unshift('ae_pc_status')
        if (!completionDate) {
          data.completion_date = new Date().toISOString()
        }
      }
      if (watch('escalated-checkbox') && !escalationDate) {
        data.escalation_date = new Date().toISOString()
        embedded.unshift('escalation_date')
      }
      if (case_id) {
        data.document_case = {
          id: case_id,
          _state: unlinkCase ? RECORD_STATE.REMOVED : RECORD_STATE.ADDED,
        }
        embedded.unshift('document_case')
      }
      await editEntityDataEmbeddedAPI(
        QUEUE_STRINGS?.AE_PC_DOCUMENT,
        documentId ?? '',
        data,
        embedded
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.SAVE_SUCCESS,
          type: 'success',
          id: uniqueId(),
        })
      )
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const setCaseCompletionDateApi = async (caseId?: string | number) => {
    try {
      await editEntityDataEmbeddedAPI(
        riDefinitionData?.global_variables?.entity_name ?? '',
        Number(caseId),
        { case_completion_date: new Date().toISOString() },
        ['case_completion_date']
      )
    } catch (error) {
      console.error(error)
    }
  }

  const handleUpdateButtonClick = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault()
    const caseId = documentDetails?.document_case?.id
    const selectedAepcId = watch('ae-pc-dropdown')
    const selectedAepc = aepcOptions.find(
      (item) => item.value === selectedAepcId
    )?.label
    if (!selectedAepc || !watch('justification-comment')) {
      dispatch(
        addToaster({
          message: NAMESPACES.REQUIRED_TOAST,
          type: 'error',
          id: uniqueId(),
        })
      )
      return
    }
    if (!caseId && selectedAepc !== INTAKE_DOCUMENT.NONE) {
      createWorkflowInstanceForRI(true)
      setIsOverrideMode(false)
      return
    }
    if (caseId && selectedAepc === INTAKE_DOCUMENT.NONE) {
      dispatch(showLoader())
      await saveAndUpdateDocument(yesNoIds?.Yes ?? 0, caseId.toString(), true)
      await caseCancelOrVoidApi(instanceId?.toString(), STRINGS.CANCEL)
      const response = await getEntityDataByIdEmbedded(
        riDefinitionData?.global_variables?.entity_name ?? '',
        Number(riDefinitionData?.global_variables?.entity_id),
        ['case_completion_date'],
        Number(caseId)
      )
      if (!response?.data?.case_completion_date) {
        await setCaseCompletionDateApi(caseId)
      }
      setRightTabs([])
      await fetchDocumentDetails()
      setIsOverrideMode(false)
      dispatch(hideLoader())
      return
    }
    await saveAndUpdateDocument(yesNoIds?.Yes ?? 0)
    await fetchDocumentDetails()
    setIsOverrideMode(false)
  }

  const handleCreateWorkflowInstance = async (
    process: WorkflowProcessType,
    instance: WorkflowInstanceType,
    isFromUpdate = false
  ) => {
    if (instance?.case_id) {
      saveAndUpdateDocument(
        isFromUpdate ? yesNoIds?.Yes ?? 0 : yesNoIds?.No ?? 0,
        instance?.case_id
      )
    }
    try {
      dispatch(showLoader())
      const response = await getEntityDataByIdEmbedded(
        process?.global_variables?.entity_name ?? '',
        Number(process?.global_variables?.entity_id),
        [
          process?.global_variables?.config?.case_status ?? '',
          process?.global_variables?.config?.case_id ?? '',
        ],
        instance.case_id ?? ''
      )
      if (response.data) {
        setRightTabs((prev) => {
          const newTabs = [...prev]
          const newTab = {
            label: `Case ID - ${response.data?.case_key}`,
            key: response?.data?.case_key,
            component: (
              <EntityLayoutWrapper
                key={response.data?.case_key}
                caseId={instance.case_id}
                definition={process}
                instance={instance}
                workflowIndex={prev.length}
              />
            ),
          }
          setDefaultActiveTab(newTab)
          newTabs.push(newTab)
          return newTabs
        })
        setLayoutInfo((prev) => {
          prev.push({
            layout: undefined,
            recordData: undefined,
          })
          return prev
        })
      }
      dispatch(
        addToaster({
          message: INTAKE_DOCUMENT.RI_CASE_CREATION_MESSAGE,
          type: 'success',
          id: uniqueId(),
        })
      )
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const createWorkflowInstanceForRI = async (isFromUpdate = false) => {
    const programEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (riDefinitionData?.global_variables?.entities?.program?.entity_id ??
          ENTITY_ID.PROGRAM.toString())
    )
    const caseSummaryEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (riDefinitionData?.global_variables?.entities?.case_summary
          ?.entity_id ?? ENTITY_ID.CASE_SUMMARY.toString())
    )
    const userEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (riDefinitionData?.global_variables?.entities?.users?.entity_id ?? '74')
    )
    const documentObject = [
      {
        document_id: documentDetails?.documents?.id,
        name: documentDetails?.documents?.document_key,
        case_document_type_id: documentDetails?.document_type?.id,
        c_ae_pc_document: {
          id: Number(documentId),
          _state: RECORD_STATE.ADDED,
        },
      },
    ]
    try {
      dispatch(showLoader())
      const embedded =
        Object?.keys(
          riDefinitionData?.global_variables?.inherited_variables || {}
        ) || []
      const faxReceivedDate =
        riDefinitionData?.global_variables?.config_fields?.case
          ?.fax_received_date ?? ''
      const receivedDate = documentDetails?.created_at
        ? new Date(documentDetails.created_at).toISOString()
        : ''
      const payload: {
        flow_meta_data: {
          process_definition_id: number
          communication_id: string
        }
        meta_data: {
          entity_name: string
          embedded: (string | undefined)[]
        }
        data: {
          [key: string]:
            | string
            | undefined
            | { id: string | undefined; _state: string }[]
            | number
            | boolean
            | null
        }
      } = {
        flow_meta_data: {
          process_definition_id: Number(riDefinitionData?.id) ?? 0,
          communication_id: documentId ?? '',
        },
        meta_data: {
          entity_name: riDefinitionData?.global_variables?.entity_name ?? '',
          embedded: [
            ...embedded,
            programEntity?.field_name ?? '',
            caseSummaryEntity?.field_name ?? '',
            userEntity?.field_name ?? '',
            riDefinitionData?.global_variables?.associated_variables?.document
              ?.parent_entity,
            ...(faxReceivedDate ? [faxReceivedDate] : []),
            'case_start_date',
            'intake_channel_id',
            'source_id',
            'communication_id',
          ],
        },
        data: {
          ...(riDefinitionData?.global_variables?.inherited_variables || {}),
          [programEntity?.field_name ?? '']: {
            id: Number(programId),
            _state: RECORD_STATE.ADDED,
          },
          [caseSummaryEntity?.field_name ?? '']: {
            record_status: 'ACTIVE',
            _state: RECORD_STATE.CHANGED,
          },
          [userEntity?.field_name ?? '']: {
            id: Number(currUserId),
            _state: RECORD_STATE.ADDED,
          },
          case_start_date: new Date(getCurrentLocalDate()).toISOString(),
          ...(riDefinitionData?.global_variables?.associated_variables?.document
            ?.parent_entity && {
            [riDefinitionData?.global_variables?.associated_variables?.document
              ?.parent_entity ?? 'c_case_documents_c_cases']: [
              ...(documentObject ?? []),
            ],
          }),
          ...(faxReceivedDate ? { [faxReceivedDate]: receivedDate } : {}),
          intake_channel_id: documentDetails?.channel?.id ?? null,
          source_id: documentDetails?.documents?.document_key,
        },
      }
      const response = await createWorkflowInstance({
        InstanceId: riDefinitionData?.id ?? '',
        data: payload,
      })
      setInstanceId(response?.data?.workflow_instance?.id)
      if (response.data) {
        handleCreateWorkflowInstance(
          response?.data?.process,
          response?.data?.workflow_instance,
          isFromUpdate
        )
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    fetchServices()
  }, [programId])

  useEffect(() => {
    fetchDefinitions()
  }, [serviceId])

  useEffect(() => {
    if (allAttachmentsData.length) handleDocumentSelected(0)
  }, [allAttachmentsData])

  useEffect(() => {
    fetchRelationshipTree({
      entityId: '32',
    })
    fetchDocumentDetails()
    setDefaultActiveTab(caseTabs[0])
  }, [])

  useEffect(() => {
    if (defaultActiveTab?.label === INTAKE_DOCUMENT.DETERMINE_AE_PC) {
      fetchDocumentDetails()
      setIsOverrideMode(false)
    }
  }, [defaultActiveTab])

  useEffect(() => {
    fetchAEPCValues()
    fetchYesOrNoIds()
  }, [categoryMap])

  useEffect(() => {
    const fetchBase64Data = async () => {
      if (
        selectedFilePath &&
        (fileType === EXTENSIONS.DOCX || fileType === EXTENSIONS.DOC)
      ) {
        try {
          const response = await convertS3ToBase64(selectedFilePath)

          const base64Data = response.data
          const byteCharacters = atob(base64Data)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {
            type:
              fileType === EXTENSIONS.DOCX
                ? MULTI_UPLOAD_FILE_TYPE.DOCX
                : MULTI_UPLOAD_FILE_TYPE.DOC,
          })
          const blobUrl = URL.createObjectURL(blob)
          setDocxPreviewUrl(blobUrl)
        } catch (error) {
          console.error('Error fetching base64 data:', error)
        }
      }
    }

    fetchBase64Data()

    return () => {
      if (docxPreviewUrl) {
        URL.revokeObjectURL(docxPreviewUrl)
      }
    }
  }, [selectedFilePath, fileType])
  return (
    <CallInteractionContextProvider
      isEditMode={isEditMode}
      handleIsEditMode={handleIsEditMode}
      layoutInfo={layoutInfo}
      setLayoutInfo={setLayoutInfo}
      tabIndexOffset={0}
      tabs={rightTabs}
      setTabs={setRightTabs}
      workflowList={[]}
    >
      <div className="h-full">
        <PanelGroup
          direction="horizontal"
          className="resize-panel-group w-full h-full"
        >
          <div className="h-full w-full flex">
            <Panel
              className="relative overflow-y-auto max-h-screen"
              defaultSize={40}
              minSize={27}
            >
              <div className="h-full w-full font-primary">
                <div className="border border-accent-100 h-full bg-white rounded resize-panelflex flex-col">
                  <div className="p-2 flex justify-between items-center">
                    <div className="flex items-center">
                      <div className="flex items-center">
                        <div className="p-1 mr-2">
                          <SvgShiftIcon className="cursor-pointer" />
                        </div>
                        <SvgVerticalSplitter />
                      </div>
                      <div className="flex gap-2 ml-2 items-center">
                        <span className="font-medium text-sm">
                          {INTAKE_DOCUMENT.DOCUMENT_ID} -{' '}
                          {documentDetails?.documents?.document_key}
                        </span>
                        <div
                          className={`px-2 py-1.5 font-light text-sm rounded ${
                            documentStatus === MODE_STATUS.PENDING
                              ? 'bg-progress-100'
                              : documentStatus === INTAKE_DOCUMENT.ESCALATED
                              ? 'bg-error-50'
                              : 'bg-success-100'
                          }`}
                        >
                          {documentStatus}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <DocumentPopout
                        source={documentUrl}
                        generateUrl={generateDocumentUrl}
                        className="h-[1.75rem] flex items-center justify-center mr-3"
                      />
                      <SvgArrowOut
                        onClick={() => openWindow()}
                        className="cursor-pointer"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (
                            e?.key === ShortcutKeys.Enter ||
                            e?.key === ShortcutKeys.Space
                          ) {
                            openWindow()
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="border-x border-b border-accent-100">
                    <FaxInfo
                      faxData={documentDetails}
                      parentEntity={INTAKE_DOCUMENT.DOCUMENT}
                    />
                  </div>
                  <div className="mb-2">
                    <Tabs
                      tabs={allTabs}
                      defaultActive={activeTab ?? undefined}
                      tabStyling="text-ellipsis max-w-[9rem] overflow-hidden"
                      onChange={(label: string, index: number) =>
                        handleTabChange(label, index)
                      }
                    />
                  </div>
                  {allTabs.length ? (
                    activeTab ? (
                      <div className="flex-1 min-h-0 relative left-col-wrap pt-12">
                        <FilePreview
                          url={documentUrl}
                          fileType={fileType}
                          docxPreviewUrl={docxPreviewUrl}
                        />
                      </div>
                    ) : null
                  ) : (
                    <div className="flex-1 min-h-0 relative left-col-wrap pt-12">
                      <FilePreview
                        url={documentUrl}
                        fileType={fileType}
                        docxPreviewUrl={docxPreviewUrl}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Panel>
            <PanelResizeHandle />
            <Panel defaultSize={60} minSize={27} className="relative">
              <div className="h-full w-full">
                <div className="h-full w-full flex flex-col">
                  <Tabs
                    tabs={caseTabs}
                    tabsWrapperClassName="pl-2 h-full flex flex-col"
                    fontWeight="font-medium"
                    defaultActive={defaultActiveTab}
                    tabsContentClassName="flex-1 min-h-0 min-w-0 overflow-auto"
                    onChange={(label, index) => {
                      setDefaultActiveTab(caseTabs[index])
                    }}
                  >
                    {renderButtons()}
                  </Tabs>
                </div>
              </div>
            </Panel>
          </div>
        </PanelGroup>
      </div>
    </CallInteractionContextProvider>
  )
}
export default IntakeDocumentReview
